import FileUpload from 'vue-upload-component';

//

var defaultOptions = {
  name: 'file',
  postAction: 'default.post.action',
  extensions: 'gif,jpg,jpeg,png,webp',
  accept: 'image/png,image/gif,image/jpeg,image/webp',
  size: 0,
  multiple: true,
  maximum: 1,
};

var script = {
  name: 'PtFileUploader',
  components: { FileUpload: FileUpload },
  props: {
    config: {
      type: Object,
      default: function default$1() {
        return defaultOptions;
      },
    },
  },
  computed: {
    options: function options() {
      return Object.assign({}, defaultOptions, this.config);
    },
  },
  methods: {
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-supported file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          this.$emit('onError', 'Your choice is not a picture');
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        var URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          var uploadedFile = newFile;
          uploadedFile.url = URL.createObjectURL(uploadedFile.file);
          this.$emit('onFileUpload', uploadedFile);
        }
      }
      return true;
    },
    upload: function upload(newFile, oldFile) {
      if (newFile && oldFile) {
        // Upload error
        if (newFile.error !== oldFile.error) {
          this.$emit('onError', newFile.error);
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          this.$emit('onSuccess', newFile.success);
        }
      }

      this.$refs.upload.active = true;
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "file-upload" },
    [
      _c(
        "file-upload",
        _vm._b(
          {
            ref: "upload",
            staticClass:
              "text-xs font-semibold rounded-full px-4 py-1 leading-normal bg-white border border-purple text-purple hover:bg-purple hover:text-white",
            attrs: { model: "files" },
            on: { "input-filter": _vm.inputFilter, "input-file": _vm.upload }
          },
          "file-upload",
          _vm.options,
          false
        ),
        [_vm._v("\n      Upload file\n    ")]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var FileUploader = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { FileUploader as PtFileUploader };
